import "./utils/userDeletedHandler";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./axios/axiosSetup.js";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
